// extracted by mini-css-extract-plugin
module.exports = {"modalBtn":"styles_modalBtn__mMeM4","file":"styles_file__1kOkX"};